<div
  class="bn-custom-amount"
  [formGroup]="form">
  <ul>
    @for (amount of predefinedAmounts; track amount) {
      <li class="bn-custom-amount__item">
        <bn-web-ui-button
          size="lg"
          [disabled]="(minAmount && amount < minAmount) || (maxAmount && amount > maxAmount) || false"
          [fullWidth]="true"
          [itemStyle]="amount === form.controls.amount.value && !showOther ? 'secondary' : 'stroke'"
          (click)="onAmountChange(amount)"
          >{{ amount }}</bn-web-ui-button
        >
      </li>
    }
    <li class="bn-custom-amount__item">
      <bn-web-ui-button
        size="lg"
        [fullWidth]="true"
        [itemStyle]="showOther ? 'secondary' : 'stroke'"
        (click)="onOtherClick()"
        >Other</bn-web-ui-button
      >
    </li>
  </ul>
  <div class="mt-2">
    @if (showOther) {
      <bn-web-ui-input
        formControlName="amount"
        placeholder="Add your own amount"
        type="number"
        [autofocus]="true"
        [hasErrorClass]="!!ngControl.control?.errors"
        [inputName]="inputName"
        [options]="{
          leftAddons: [
            {
              icon: 'circle-dollar',
            },
          ],
        }" />
    }
  </div>
</div>
<bn-web-ui-formcontrol-errors
  [control]="ngControl.control"
  [inputDisplayName]="inputName || 'Amount'" />
